import React from 'react';
import { Check } from 'lucide-react';
import { ServicePageLayout } from '../components/ServicePageLayout';
export function CeramicCoatingPage() {
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Service',
    name: 'Ceramic Coating',
    provider: {
      '@type': 'LocalBusiness',
      name: "Mike's Pro Detail",
      telephone: '+18183819905'
    },
    areaServed: ['Camarillo', 'Thousand Oaks', 'Ventura County', 'Los Angeles'],
    description: 'Professional ceramic coating application for ultimate paint protection, extreme gloss, and hydrophobic water beading.'
  };
  return <ServicePageLayout title="Ceramic Coating in Los Angeles & Ventura County" subtitle="Experience the ultimate in paint protection. Ceramic coatings provide years of durable protection, extreme gloss, and effortless maintenance." metaDescription="Professional ceramic coating in Camarillo, Thousand Oaks, and Ventura County. Long-lasting paint protection and extreme gloss. Call (818) 381-9905." schema={schema} data-id="element-258">
      <p data-id="element-259">
        If you want the absolute best protection for your vehicle's paint,
        traditional waxes and sealants simply cannot compete with a professional{' '}
        <strong data-id="element-260">Ceramic Coating</strong>. At Mike's Pro Detail, we offer premium
        ceramic coating applications that bond at a molecular level with your
        vehicle's clear coat. This creates a semi-permanent, glass-like shield
        that protects against the harsh elements of Southern California. Whether
        you're driving through Thousand Oaks or parked under the sun in
        Camarillo CA, our mobile ceramic coating service ensures your vehicle
        remains protected and incredibly glossy for years.
      </p>

      <h2 data-id="element-261">What is a Ceramic Coating?</h2>
      <p data-id="element-262">
        A ceramic coating is a liquid polymer (typically silica-based) that is
        carefully applied by hand to the exterior of a vehicle. Once cured, it
        chemically bonds with the factory paint, creating a rigid, hydrophobic
        (water-repelling) layer of protection. Unlike carnauba wax that melts
        away in a few weeks, or synthetic sealants that last a few months, a
        true ceramic coating can last for years when properly maintained.
      </p>

      <h2 data-id="element-263">The Benefits of Ceramic Coating</h2>

      <ul className="space-y-4 my-6 list-none pl-0" data-id="element-264">
        <li className="flex items-start" data-id="element-265">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-266" />
          <span data-id="element-267">
            <strong data-id="element-268">Extreme Hydrophobic Properties:</strong> Water aggressively
            beads up and rolls off the surface, taking dirt and grime with it.
            This self-cleaning effect makes washing your car incredibly easy.
          </span>
        </li>
        <li className="flex items-start" data-id="element-269">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-270" />
          <span data-id="element-271">
            <strong data-id="element-272">UV Damage & Oxidation Prevention:</strong> The coating
            blocks harmful UV rays, preventing your paint from oxidizing,
            fading, and looking dull over time.
          </span>
        </li>
        <li className="flex items-start" data-id="element-273">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-274" />
          <span data-id="element-275">
            <strong data-id="element-276">Chemical Resistance:</strong> Protects against acidic bird
            droppings, tree sap, bug splatter, and harsh chemicals that would
            normally etch into the clear coat.
          </span>
        </li>
        <li className="flex items-start" data-id="element-277">
          <Check className="w-6 h-6 text-red-500 mr-3 shrink-0 mt-1" data-id="element-278" />
          <span data-id="element-279">
            <strong data-id="element-280">Unmatched Candy-Like Gloss:</strong> Enhances the reflective
            properties of your paint, adding depth and clarity that makes your
            car look like it's encased in glass.
          </span>
        </li>
      </ul>

      <h2 data-id="element-281">The Application Process</h2>
      <p data-id="element-282">
        Applying a ceramic coating requires meticulous preparation. The paint
        must be absolutely perfect before the coating is applied, as the coating
        will lock in any existing defects. Our process includes a thorough wash,
        chemical iron decontamination, a clay bar treatment, and a machine paint
        correction (polishing) to remove swirl marks and scratches. Only after
        the paint is flawless do we apply the ceramic coating, ensuring maximum
        bonding and longevity.
      </p>

      <h2 data-id="element-283">Why Choose Us for Ceramic Coatings?</h2>
      <p data-id="element-284">
        Applying a ceramic coating is a highly technical process that requires a
        controlled environment, patience, and expertise. When searching for "Car
        Detailing Camarillo" or "Mobile Detailing Ventura County" for high-end
        protection, Mike's Pro Detail is the premier choice. We use only
        industry-leading, professional-grade coatings and take the necessary
        time to prep your vehicle correctly. Protect your investment with the
        ultimate shield—contact us today to discuss the best ceramic coating
        package for your vehicle.
      </p>
    </ServicePageLayout>;
}